/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TicketIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABbklEQVR4nM2VPU7DUAzHk2twB8TUDVgRIs92Bp5dpg5IvQFiZwBWPi+ABKwUwVJxDc5QegEQNEVO0zQfBKX5kGrJS2T9/n7/Z784zqoFIm8B8iOgDAxyz3Ect0F4t2+QJ0AyjRPlpin4IZAEKTjJ1BA/NSJgSN6y8FAA5bR25yaE8xiILwzyKC3Az3Xg/dgWlMvZt4N1IPlOiATg8349OGnyeM+3GwCyBiSfGasCPQmQnEXTdfvvdOXhMvf7x6B8GZQ7ROasXRnrekvBIZEK11qPeLewDmVQCQ6z7kaIdscgnxTVG5T7SnDIeO/5tqMJKB+JBiYedTdjOIDdzm1oyfR82wkZxMdzUW021b0heagCh8gug3IEyO9AMtS9yXmvF1JVABY5LBxLHama8ODPzhPhAvH1Yln4dYkLD3KelwnwrZQQqQaPRVBeWoOHAsTnrcE19GfSGjwUQL7KzPykMXgUro6wnkTfltT6r0r8AhG475yHH5eAAAAAAElFTkSuQmCC)
 */
export const TicketIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2.1 12a3 3 0 0 0 0 4.24l.46.46c.17.17.43.2.65.1a3 3 0 0 1 4 4c-.1.2-.08.47.09.64l.46.46a3 3 0 0 0 4.24 0l6.77-6.77a1 1 0 0 1 1.36-1.36L21.9 12a3 3 0 0 0 0-4.24l-.46-.47a.56.56 0 0 0-.65-.08 3 3 0 0 1-4-4 .56.56 0 0 0-.08-.65l-.47-.46a3 3 0 0 0-4.24 0l-1.77 1.77a1 1 0 0 1-1.36 1.36L2.1 12Zm10.01-6.3A1 1 0 0 0 10.7 7.1l.69.7a1 1 0 0 0 1.41-1.42l-.69-.7Zm2.75 2.75a1 1 0 0 0-1.41 1.41l.69.7a1 1 0 0 0 1.41-1.42l-.69-.7Zm2.75 2.75a1 1 0 0 0-1.41 1.41l.69.7a1 1 0 0 0 1.41-1.42l-.69-.7Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
